import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import HeaderIcon from '../Icons/HeaderIcon';
import HistoryHeaderIcon from '../Icons/HistoryHeaderIcon';

const Header = () => {
  const { t } = useTranslation('beneficiaries');

  const [searchParams] = useSearchParams();

  const page = searchParams.get('p');

  const isHistoryPage = page === 'historico-importacoes';

  const labelTitle = isHistoryPage ? t('title_history') : t('title');

  const labelSubTitle = isHistoryPage ? t('subtitle_history') : t('subtitle');

  return (
    <>
      <div className="w-100 main-page-container">
        <div className="w-100 container-header">
          <div className="header-main-page">
            <h1 className="title-main-page mb-0">{labelTitle}</h1>
            <h3 className="subtitle-main-page">{labelSubTitle}</h3>
          </div>
          <div className="img-container">{isHistoryPage ? <HistoryHeaderIcon /> : <HeaderIcon />}</div>
        </div>
        <div className="container-header-mobile">
          <div className="img-container">
            <div className="title-wrapper">
              <span className="title">{labelTitle}</span>
              <span className="subtitle">{labelSubTitle}</span>
            </div>
            <div className="mobile-img">{isHistoryPage ? <HistoryHeaderIcon /> : <HeaderIcon />}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
